import { MQ_SMALL_ONLY, MQ_MIDLARGE, MQ_LARGE, MQ_MEDIUM } from 'constants/mq';
import IMAGE_SIZES from 'constants/imageSizes';

const { base16x9, large16x9 } = IMAGE_SIZES;

const base = {
  fallbackDims: base16x9,
  sourceSets: [
    {
      layoutWidth: { value: 147, units: 'px' },
      imageDims: large16x9,
      media: MQ_MIDLARGE
    },
    {
      layoutWidth: { value: 120, units: 'px' },
      imageDims: large16x9,
      media: MQ_LARGE
    },
    {
      layoutWidth: { value: 15, units: 'vw' },
      imageDims: large16x9,
      media: MQ_MEDIUM
    },
    {
      layoutWidth: { value: 100, units: 'vw' },
      imageDims: large16x9,
      media: MQ_SMALL_ONLY
    }
  ],
  placeholders: [
    {
      media: '(min-width: 0px)',
      ratio: 16 / 9
    }
  ]
};

const exceptionPatterns = undefined;

export default {
  base,
  exceptionPatterns
};
